import React from "react";
import ContactLink from "./ContactLink";
import {ENQUIRE_EMAIL, LINKED_IN_URL, CONTACT_URL, INSTAGRAM_URL, THREE_D_MODEL_LINK_URL, VIDEO_LINK_URL, SEND_TO_EMAIL} from '../../globalConstants/GlobalConstants';


const ContactLinksModal = (props) => {

    const onSendEmail = () => {
        window.location = props.annotationData.EnquireEmail;
    }

    const goToPage = (urlLink) => {
        window.open(urlLink, '_blank');
    }

    const shareEmail = () => {
        window.location = props.annotationData.shareEmail;
    }

    /* isVerticalBar expects a boolean value, to check whether it is needed to populate the verticalbar (pipe) or not  */
    let enquire = null;
    if(props.annotationData.EnquireEmail) {
        enquire = <ContactLink contactName={ENQUIRE_EMAIL} isVerticalBar={false} hrefLink={props.annotationData.EnquireEmail} onClickHandler={onSendEmail.bind(this)} />;
    }

    let sendToEmail = null
    if(props.annotationData.isSendTo === 'Y') {
        sendToEmail = <ContactLink contactName={SEND_TO_EMAIL} isVerticalBar={props.annotationData.EnquireEmail} hrefLink={props.annotationData.shareEmail} onClickHandler={shareEmail.bind(this)} />;
    }

    let linkedInUrl = null;
    if(props.annotationData.linkedInIUrl) {
        linkedInUrl = <ContactLink contactName={LINKED_IN_URL} isVerticalBar={enquire} hrefLink={props.annotationData.linkedInIUrl} onClickHandler={() => goToPage(props.annotationData.linkedInIUrl)}/>;
    }

    let instigramUrl = null;
    if(props.annotationData.instagramUrl) {
        instigramUrl = <ContactLink contactName={INSTAGRAM_URL} isVerticalBar={enquire || linkedInUrl} hrefLink={props.annotationData.instagramUrl} onClickHandler={() => goToPage(props.annotationData.instagramUrl)}/>;
    }

    // const questions = <ContactLink contactName="QUESTIONS" isVerticalBar={true} hrefLink={this.state.EnquireEmail} onClickHandler={this.onSendEmail} />;
    let verticalBarValue = props.hasMediaCarouselLink;
    let websiteUrl = null;
    if(props.annotationData.ContactURL) {
        websiteUrl = <ContactLink contactName={CONTACT_URL} isVerticalBar={verticalBarValue} hrefLink={props.annotationData.ContactURL} onClickHandler={() => goToPage(props.annotationData.ContactURL)}/>;
    }
    verticalBarValue = props.hasMediaCarouselLink || websiteUrl;

    let videoLinkUrl = null;
    if(props.annotationData.videoLinkUrl) {
        videoLinkUrl = <ContactLink contactName={VIDEO_LINK_URL} isVerticalBar={verticalBarValue} hrefLink={props.annotationData.videoLinkUrl} onClickHandler={() => goToPage(props.annotationData.videoLinkUrl)}/>;
    }
    verticalBarValue = props.hasMediaCarouselLink || websiteUrl || videoLinkUrl;

    let _3DModelUrl = null;
    if(props.annotationData._3DModelLinkUrl) {
        _3DModelUrl = <ContactLink contactName={THREE_D_MODEL_LINK_URL} isVerticalBar={verticalBarValue} hrefLink={props.annotationData._3DModelLinkUrl} onClickHandler={() => goToPage(props.annotationData._3DModelLinkUrl)}/>;
    }



    return (
        <div className="annotation-contact-container">
            <h6>
                {enquire} {sendToEmail} {linkedInUrl} {instigramUrl}
            </h6>
            <h6>
                {props.hasMediaCarouselLink} {websiteUrl} {videoLinkUrl} {_3DModelUrl}
            </h6>

        </div>
    )
}

export default ContactLinksModal;